import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/app/[locale]/(commonAuthenticatedLayout)/page.tsx");
